// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import styled from 'styled-components';

const StyledWrapper = styled.div`
    display: ${props => (props.styles && props.styles.display) || 'flex'};
    align-items: center;
    flex-wrap: wrap;
    width: 100%;

    .checkbox {
        margin: 0;
        margin-right: 20px;
        margin-top 10px;
        margin-bottom: 10px;    
        label {
            display: inline-flex;
            position: relative;
            width: auto;
            padding: 0;
            margin: 0;
            padding-left: 30px;
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 21px;
                height: 21px;
                background: #ffffff;
                border: 1px solid #adb5bd;
            }
        }
      
        input { 
           display: none; 
       }
       
       input:checked+label::before {
            background: #B62767;
            border-color: #B62767;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 50% 50%;
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e");
       }
    }
\`;
`;

const Checkboxes = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  options,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onChange,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  values,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  noLabel,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  disabled,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  styles,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  label,
}) => (
  <StyledWrapper styles={styles}>
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/prop-types */}
    {options.map(option => (
      <div className='checkbox' key={option.value}>
        <input
          type='checkbox'
          id={label + option.value}
          value={option.value}
          onChange={onChange}
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          checked={values?.includes(option.value)}
          disabled={disabled}
        />
        <label htmlFor={label + option.value}>
          {noLabel ? '' : option.label}
        </label>
      </div>
    ))}
  </StyledWrapper>
);

export default Checkboxes;
